<template>
  <div>
    <v-container grid-list-xs>
      <v-card flat>
        <v-textarea
          v-model="form.text"
          outlined
          dense
          label="ข้อความ"
          :rules="[$store.getters.TextRule(form.text)]"
          name="input-7-4"
          clearable
        ></v-textarea>
      </v-card>
      <v-card flat class="custom-qr">
        <v-row v-for="(quickreply, i) in form.buttons" :key="i" no-gutters>
          <v-col cols="9">
            <v-text-field
              v-model="quickreply.text"
              outlined
              dense
              label="ตัวเลือก"
              :error="quickreply.errorLabel"
              :error-messages="quickreply.errorLabelMsg"
              @input="DuplicatedButton()"
              @click:clear="DuplicatedButton()"
              :rules="[$store.getters.ButtonRule(quickreply.text)]"
              counter="20"
              clearable
              @keydown.enter.prevent
              @keydown="maxLengthCount($event, quickreply.text)"
            >
              <template #counter="{ props }">
                <span style="font-size: 12px; color: rgba(0, 0, 0, 0.6)"
                  >{{ RealTextLength(quickreply.text) }} / {{ props.max }}</span
                >
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  v-on="on"
                  v-show="Object.keys(form.buttons).length > 1"
                  :disabled="!quickreply.text"
                >
                  <v-avatar size="22" rounded>
                    <img
                      src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZmlsbD0iIzAwMDAwMCIgZD0iTTMxLjYsNy45aC0xOWMtMS4yLDAtMi4yLDEtMi4yLDIuMnYxOC41YzAsMS4yLDEsMi4yLDIuMiwyLjJoMTljMS4yLDAsMi4yLTEsMi4yLTIuMlYxMC4xICAgQzMzLjgsOC45LDMyLjgsNy45LDMxLjYsNy45eiI+PC9wYXRoPjxwYXRoIGZpbGw9IiMwMDAwMDAiIGQ9Ik0zMS42LDM3LjNoLTE5Yy0xLjIsMC0yLjIsMS0yLjIsMi4ydjE4LjVjMCwxLjIsMSwyLjIsMi4yLDIuMmgxOWMxLjIsMCwyLjItMSwyLjItMi4yVjM5LjQgICBDMzMuOCwzOC4yLDMyLjgsMzcuMywzMS42LDM3LjN6IE0yNy4yLDUzLjZIMTYuOXYtOS44aDEwLjNWNTMuNnoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNMzEuNiw2Ny43aC0xOWMtMS4yLDAtMi4yLDEtMi4yLDIuMnYxOC41YzAsMS4yLDEsMi4yLDIuMiwyLjJoMTljMS4yLDAsMi4yLTEsMi4yLTIuMlY2OS44ICAgQzMzLjgsNjguNywzMi44LDY3LjcsMzEuNiw2Ny43eiBNMjcuMiw4NEgxNi45di05LjhoMTAuM1Y4NHoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNNzUuNSwxOS41bDEuOS00YzEuMy0yLjgtMC44LTYtMy45LTUuN2wtMjYuOCwyLjFjLTIuOSwwLjItNC41LDMuNS0yLjksNmwxNC42LDIxLjNjMiwyLjksNi40LDIuNiw3LjktMC42ICAgbDEuOS0zLjljMC41LTEsMS44LTEuMywyLjYtMC42YzYuMiw1LjIsMTAuMSwxMi45LDEwLjEsMjEuNmMwLDExLjgtNy4zLDIxLjktMTcuNSwyNi4xYy0yLjEsMC45LTMuNiwyLjgtMy43LDUgICBjLTAuMiw0LjEsMy45LDcuMSw3LjcsNS41YzE0LjUtNS44LDI0LjgtMjAuMSwyNC44LTM2LjdjMC0xMi44LTYuMS0yNC4xLTE1LjUtMzEuNEM3NS4yLDIzLjEsNzQuNywyMS4yLDc1LjUsMTkuNXoiPjwvcGF0aD48L2c+PC9zdmc+"
                      :style="{
                        filter: `invert(0.5) sepia(${
                          !quickreply.text ? 0 : 1
                        }) saturate(5) hue-rotate(175deg)`,
                      }"
                    />
                  </v-avatar>
                </v-btn>
              </template>
              <v-card>
                <v-list>
                  <v-list-item
                    v-for="(item, im) in form.buttons"
                    :key="im"
                    @click="MoveButton(i, im)"
                    v-show="i !== im && item.text"
                  >
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-btn
              color="#DE4F3B"
              v-show="Object.keys(form.buttons).length > 1"
              icon
              @click="$delete(form.buttons, i), DuplicatedButton()"
              ><v-icon>delete</v-icon></v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-card flat class="d-flex justify-center">
      <v-btn
        color="primary"
        @click="AddLabel"
        v-if="Object.keys(form.buttons).length < 10"
        small
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
import _ from "lodash";
export default {
  props: ["form"],
  data() {
    return {
      qtype: [
        {
          text: "Text",
          value: "text",
        },
        {
          text: "Webview",
          value: "webview",
        },
        {
          text: "Link",
          value: "link",
        },
      ],
      qsize: [
        {
          text: "Compact",
          value: "compact",
        },
        {
          text: "Tall",
          value: "tall",
        },
        {
          text: "Full",
          value: "full",
        },
      ],
    };
  },
  methods: {
    maxLengthCount(e, text) {
      if (e.key === "Backspace" || e.key === "Delete") {
        return false;
      } else {
        if (this.RealTextLength(text) >= 20) {
          e.preventDefault();
        }
      }
    },
    RealTextLength(text) {
      return _.toArray(text).length;
    },
    AddLabel() {
      this.form.buttons.push({
        type: "text",
        text: "",
        errorLabel: false,
        errorLabelMsg: "",
      });
    },
    MoveButton(index, moveindex) {
      let old_index = index;
      let new_index = moveindex;
      if (new_index >= this.form.buttons.length) {
        var k = new_index - this.form.buttons.length + 1;
        while (k--) {
          this.form.buttons.push(undefined);
        }
      }
      this.form.buttons.splice(
        new_index,
        0,
        this.form.buttons.splice(old_index, 1)[0]
      );
    },
    DuplicatedButton() {
      this.form.buttons.map((item) => {
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(this.form.buttons, "text");
      let dup = _.filter(this.form.buttons, (x) => counts[x.text] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.text) {
            item.errorLabel = true;
            item.errorLabelMsg = "ชื่อ label นี้มีอยู่ใน list ของคุณแล้ว";
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.custom-qr >>> .v-messages__message {
  margin-top: 3px;
}
</style>
